export const titleFormGroupSx = (isMobile: boolean) => ({
  display: 'flex',
  gap: '16px',
  flexWrap: 'nowrap',
  alignItems: isMobile ? 'stretch' : 'center',
  flexDirection: isMobile ? 'column' : 'row',
});

export const avatarSx = {
  flexShrink: 0,
};
